import { Component, OnDestroy, inject } from '@angular/core';
import { AppRoutes } from '@bn/dashboard-core/enums';
import { ContentService } from '@bn/shared/services';
import { AppShieldEventLogsSearchComponent } from '../../components/app-shield-event-logs-search';
import { AppShieldEventLogsSearchStore, ShieldApiStore } from '../../stores';

@Component({
  templateUrl: './app-shield-event-log.page.html',
  styleUrls: ['./app-shield-event-log.page.scss'],
  imports: [AppShieldEventLogsSearchComponent],
  providers: [AppShieldEventLogsSearchStore],
})
export class AppShieldEventLogPage implements OnDestroy {
  readonly #shieldStore = inject(ShieldApiStore);

  public readonly contentService = inject(ContentService);

  constructor() {
    const pullZoneId = this.#shieldStore.pullZoneId();

    this.contentService.setTitle('Event logs');
    this.contentService.setBackButton({
      routerLink: `/${AppRoutes.CDN}/${pullZoneId}/${AppRoutes.Shield}`,
    });
  }

  public ngOnDestroy(): void {
    this.contentService.setBackButton(null);
  }
}
